<mat-chip-set>
	<mat-chip *ngFor="let item of items"
			  removable
			  #chipTooltip="matTooltip"
			  [matTooltip]="getName(item)"
		[class.st-staff-id-list-multiple-chip-max-width-long]="asCustomField && value?.length == maxItemsToShow"
		[class.st-staff-id-list-multiple-chip-max-width-short]="asCustomField && value?.length > maxItemsToShow"
		[class.st-staff-id-list-multiple-chip-max-width]="asCustomField"
	    (removed)="remove(item)"
		[disabled]="disabled">
		{{getName(item)}}
		<button matChipRemove
				[attr.aria-label]="'remove ' + item"
				[disabled]="disabled">
			<mat-icon>close</mat-icon>
		</button>
		<avatar matChipAvatar
				small
				[userId]="item"></avatar>
	</mat-chip>
	<mat-chip *ngIf="asCustomField && value?.length > maxItemsToShow"
		class="st-staff-id-list-multiple-chip-max-width st-staff-id-list-multiple-chip-max-width-short"
		#tooltip="matTooltip"
			  [matTooltip]="usersAsTooltip"
			  [matMenuTriggerFor]="listDropDownMenu"
			  (menuOpened)="onMenuOpened()"
			  [disabled]="disabled">
		{{ '+' + (value?.length - maxItemsToShow) + ' more' }}
	</mat-chip>
	<button mat-button
			[class.st-staff-id-list-multiple-button-valid]="(required && value && value?.length === 0) || !value"
			[class.st-staff-id-list-multiple-button-required]="required"
			[matMenuTriggerFor]="listDropDownMenu"
			(menuOpened)="onMenuOpened()"
			(menuClosed)="valueChanged()"
			class="st-staff-id-list-multiple-button"
			listDropDownMenu
            *ngIf="!disabled"
			[disabled]="disabled">
		<span [class.st-staff-id-list-multiple-button-label]="asCustomField"
			  [class.st-staff-id-list-multiple-button-label-long]="asCustomField && value?.length == maxItemsToShow"
			  [class.st-staff-id-list-multiple-button-label-short]="asCustomField && value?.length > maxItemsToShow">{{label || placeholder}}</span>
		<mat-icon>add</mat-icon>
	</button>
</mat-chip-set>

<mat-menu #listDropDownMenu="matMenu"
		  class="st-staff-id-list-multiple-menu">
	<form click-stop-propagation
		  class="st-staff-id-list-multiple-form"
		  [dir]="dir">
		<mat-form-field appearance="fill"
						subscriptSizing="dynamic"
						class="st-staff-id-list-multiple-form-search">
			<mat-icon matPrefix>search</mat-icon>
			<input #searchBox
				   matInput
				   [placeholder]="searchLabel"
				   [formControl]="staffFilter">
		</mat-form-field>
		<mat-selection-list [multiple]="false"
							hideSingleSelectionIndicator="true"
							[ngModel]="value"
			click-stop-propagation
							(selectionChange)="onSelectionChange($event)">
			<mat-list-option *ngFor="let userId of  filteredOptions | async"
							 [value]="userId">
				<avatar matListItemAvatar
						big
						class="st-staff-id-list-multiple-form-avatar"
						[userId]="userId"></avatar>
				<div matListItemTitle>{{getName(userId)}}</div>
				<div matListItemLine>{{getEmail(userId)}}</div>
			</mat-list-option>
		</mat-selection-list>
	</form>
</mat-menu>
